export default "__VITE_ASSET__60a8a6ce__"